/* Big Boilers — minimal vanilla theme JS */
(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  var panel = document.querySelector('[data-bb-mobile-panel]');
  var overlay = document.querySelector('[data-bb-overlay]');
  var openers = document.querySelectorAll('[data-bb-menu-open]');
  var closers = document.querySelectorAll('[data-bb-menu-close]');
  var lastFocus = null;

  function setMenu(open) {
    if (!panel) return;
    panel.setAttribute('data-open', open ? 'true' : 'false');
    if (overlay) overlay.setAttribute('data-open', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      lastFocus = document.activeElement;
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }
  openers.forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  closers.forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && panel.getAttribute('data-open') === 'true') setMenu(false);
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-qty]');
    if (!btn) return;
    var wrap = btn.closest('.bb-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-bb-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart line item quantity auto-submit ---------- */
  document.querySelectorAll('[data-bb-cart-qty] input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- collection sort ---------- */
  var sort = document.querySelector('[data-bb-sort]');
  if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

  /* ---------- product media gallery ---------- */
  document.querySelectorAll('[data-bb-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-bb-gallery-main]');
    gallery.querySelectorAll('[data-bb-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-bb-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- variant picker ---------- */
  document.querySelectorAll('[data-bb-variants]').forEach(function (root) {
    var dataEl = root.querySelector('[data-bb-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-bb-variant-id]');
    var priceEl = root.querySelector('[data-bb-price]');
    var compareEl = root.querySelector('[data-bb-compare]');
    var submit = root.querySelector('[data-bb-add]');
    var money = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }
    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-bb-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function matchVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      })[0];
    }
    function update() {
      var opts = selectedOptions();
      var variant = matchVariant(opts);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.getAttribute('data-label-add')
          : submit.getAttribute('data-label-soldout');
      }
      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-bb-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (form) {
      form.addEventListener('submit', function () {
        document.dispatchEvent(new CustomEvent('bb:add-to-cart', { detail: { form: form } }));
      });
    }
    update();
  });

  /* ---------- analytics hooks (no app required) ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bb-event]');
    if (!el) return;
    var name = el.getAttribute('data-bb-event');
    var detail = { label: el.getAttribute('data-bb-label') || el.textContent.trim().slice(0, 80) };
    document.dispatchEvent(new CustomEvent('bb:' + name, { detail: detail }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: 'bb_' + name }, detail));
    }
  });
})();

/* Get a Quote: jump straight to the quote form */
(function () {
  function findForm() { return document.querySelector('form.bb-quote-form, .bb-quoteband form, #quote form'); }
  function go(form, smooth) {
    var target = form.closest('.bb-form') || form;
    var header = document.querySelector('.bb-header, header');
    var off = header && getComputedStyle(header).position.match(/sticky|fixed/) ? header.offsetHeight + 12 : 12;
    window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - off), behavior: smooth ? 'smooth' : 'auto' });
    var first = form.querySelector('input:not([type=hidden]), select, textarea');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, smooth ? 500 : 50);
  }
  function isQuote(a) { try { var u = new URL(a.href, location.href); return u.origin === location.origin && /\/pages\/quote\/?$/.test(u.pathname); } catch (e) { return false; } }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    var same = a.getAttribute('href') === '#quote';
    if (!same && !isQuote(a)) return;
    var form = findForm(), u = new URL(a.href, location.href);
    if (form && (same || !u.search || u.pathname === location.pathname)) { e.preventDefault(); go(form, true); return; }
    if (!same && !u.hash) { e.preventDefault(); u.hash = 'quote-form'; location.href = u.toString(); }
  });
  function onLoad() { if (location.hash === '#quote-form' || location.hash === '#quote') { var f = findForm(); if (f) setTimeout(function () { go(f, false); }, 60); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();
})();
